'use client';

import { useEffect } from 'react';

/**
 * Auto-scrolls to a bottom sentinel ref when any dependency changes.
 *
 * The caller owns the trigger key because each consumer has different
 * scroll triggers (e.g. message count, streaming status, part count).
 * Pass a single primitive value (or a composite string) that changes
 * whenever scrolling should fire.
 */
export function useChatAutoScroll(
  bottomRef: React.RefObject<HTMLDivElement | null>,
  triggerKey: string | number | boolean,
): void {
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [bottomRef, triggerKey]);
}
